const AndroidData = [
  {
    core: [
      {
        id: "1",
        name: "Introduction to Kotlin",
        karma: "400",
        description:
          "Learn the Kotlin programming language in this introduction to Kotlin. Kotlin is a general purpose, open source, statically typed “pragmatic” programming language. It is used for many things, including Android development.",
        link: "https://www.youtube.com/watch?v=F9UC9DY-vIU",
        inner_description:
          "After course completion, complete the assignment and post the Repository url in the #android-development channel of the µLearn Discord server with the hashtag #android-kotlin-intro to avail karma points",
        assignment: [
          {
            assignment_description:
              "Now that you have learnt the basics of Kotlin, it’s time to test yourselves by building a simple Todo App Manager using Kotlin. You have all the freedom to design it however you like! Submit your completed project to the Github repository",
            example:
              "#android-kotlin-intro Hey I’ve completed the Intro to Kotlin Course. Check my Todo App.",
          },
        ],
      },
      {
        id: "2",
        name: "Android Basics with Compose",
        karma: "1200",
        description:
          "In this course, you'll learn the basics of building Android apps with Jetpack Compose, the new UI toolkit for building Android apps. Along the way, you'll develop a collection of apps to start your journey as an Android developer.",
        link: "https://developer.android.com/courses/android-basics-compose/course",
        inner_description:
          "After course completion, share the 4 badges you’ve earned in #android-development channel of the µLearn Discord server with the hashtag #android-compose to avail karma points.",
      },
    ],
    sub: [
      {
        id: "1",
        name: "Git and GitHub",
        karma: "200",
        description:
          "Git is a piece of software that makes it simpler to manage different versions of your own software in a software repository.  GitHub is a place to share software repositories and collaborate with other developers. These tools make it easier for multiple people to work on the same software project. In this course you will learn about: Installing Git, Creating a Git Repository, Cloning a Git Repository, Adding and Removing from a Git repository, Using GitHub, creating pull requests, branching repositories, merging repositories.By the end of the course, you'll know way more about Git than the people in this web comic. :)",
        link: "https://www.youtube.com/watch?v=RGOj5yH7evk",
        inner_description:
          "Now if you go to the pull requests tab in GTech µLearn repo, you’ll be able to see your pull request. Open it and copy your pull request URL.",
        example:
          "#android-git-github Submit the link in #android-development channel with the hashtag,",
        assignment: [
          {
            assignment_description:
              "Just like knowing how to use the Command Line, Git & Github will be very important in your daily workflow as a programmer / developer. Let’s put your Git and Github skills to practice! Find the assignment below.",
            assignment_inner_description: "",
            link: "https://mulearn.notion.site/Git-GitHub-b8a840efb00845d2a2ab1c2877b1952c",
          },
        ],
      },
    ],
  },
];

export default AndroidData;
